import ExpiredStorage from "expired-storage";

const version = "0.0.62";

/**
 * Use this sparingly. Local Storage has a limit of 10MB (shared with session storage).
 */
class CachedRepository {
  expiredStorage = null;

  constructor() {
    this.expiredStorage = new ExpiredStorage();
  }

  /**
   * @property {string} cacheName
   * @property {Promise} promiseCallback a callback that returns a promise whose result can be cached.
   * @property {number} expiry. Defaults to a week.
   */
  cacheResponse(cacheName, promiseCallback, expiry = 604800) {
    const storedVersion = this.expiredStorage.getItem("react_app_version");

    if (storedVersion !== version) {
      this.expiredStorage.clear();
      // expire weekly. This will force all cache to be cleared even if "expiry" variable
      // has a higher value.
      this.expiredStorage.setItem("react_app_version", version, 60 * 60 * 24 * 7);
    }

    const data = this.expiredStorage.getJson(cacheName);

    // If we have cached data and no burst is needed, then return the saved data.
    if (data) {
      return Promise.resolve(data);
    }

    return promiseCallback().then(response => {
      this.expiredStorage.setJson(cacheName, response, expiry);

      return response;
    });
  }
}

export default CachedRepository;
